import Ws from '@adonisjs/websocket-client'
import configs from './../config'

export default Ws(configs.getWsUrl());
